import React, { useEffect, useState } from 'react';
import { Card, Button } from 'antd';
import CreateExerciseModal from './exercise_create_modal';
import EditingExerciseModal from './exercise_editing_modal';
import { restApi } from '../../../apis';
import ExercisePopover from './exercise_popover';

/*
restUrl :{
	create:'',
	read:'',
	update:'',
	delete:''
}
*/

const ExerciseItem = (props) => {
  const data = props.data;
  const messageApi = props.messageApi;
  const index = props.index;
  const OnCellClick = props.OnCellClick;
  const onRefresh = props.onRefresh;
  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      height: '3.5rem',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',

      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '2.1rem',
      // d
      padding: '7px 10px',
      background: '#FFFFFF',
      border: '0.5px solid #7367F0',
      boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
      borderRadius: '4px',

      marginTop: index === 0 ? 20 : 10,
    },
  };
  return (
    <div style={{ ...styles.container }}>
      <Button
        // type="primary"
        style={{ display: 'flex', width: '90%', justifyContetn: 'flex-start' }}
        type="text"
        onClick={(e) => {
          return OnCellClick({ id: data.id });
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            wordWrap: true,
            // justifyContetn: 'center',
            // alignItems: 'center',
          }}
        >
          {data?.kor_name}
          {data?.is_public != 'T' && (
            <div
              style={{
                display: 'flex',
                marginLeft: '1rem',
                color: 'red',
                // justifyContetn: 'center',
                // alignItems: 'center',
              }}
            >
              {'비공개'}
            </div>
          )}
        </div>
      </Button>
      {/* <img
        width={22}
        height={22}
        src={require('../../../assets/images/ico_more.png')}
      /> */}
      {/* <div>{data?.eng_name}</div> */}

      <ExercisePopover
        {...props}
        big={props?.big}
        mid={props?.mid}
        sml={props?.sml}
        messageApi={messageApi}
        isPublic={data?.is_public}
        uuid={data?.id}
        eng_name={data?.eng_name}
        kor_name={data?.kor_name}
        onRefresh={onRefresh}
        width={30}
        component={
          <img
            width={22}
            height={22}
            src={require('../../../assets/images/ico_more.png')}
          />
        }
      />
    </div>
  );
};

const ExerciseName = (props) => {
  const {
    title,
    setGModal,
    categoryId = '',
    setLoading,
    parentId = '',
    big = '',
    mid = '',
    sml = '',
    messageApi,
    ...rest
  } = props;
  const [state, setState] = useState({ loading: false, data: [], value: null });

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
      // justifyContent: 'flex-start',
      padding: 0,
      margin: 0,

      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    body: {
      display: 'flex',
      width: '100%',
      height: '67vh',
      flexDirection: 'column',
      alignItems: 'flex-start',
      overflow: 'auto',
    },
  };

  const initData = () => {
    if (String(categoryId).length > 0) {
      setState((prev) => {
        return {
          ...prev,
          loading: true,
        };
      });

      (async () => {
        const response = await restApi.get(
          `/admin/category/${categoryId}/exercise`
        );
        const payload = response?.data?.payload;
        if (payload) {
          setState((prev) => {
            return {
              ...prev,
              data: payload.exercises || [],
              loading: false,
              reload: false,
            };
          });
        }
      })();

      setTimeout(() => {
        if (state.loading) {
          setState((prev) => {
            return {
              ...prev,
              loading: false,
            };
          });
        }
      }, 5000);
    }
  };

  useEffect(() => {
    // console.log('---->', parentId);
    // 값 가져오기
    if (categoryId.length > 0) {
      // 데이터 가져오기
      initData();
    } else {
      setState((prev) => {
        return {
          ...prev,
          loading: false,
          data: [],
          value: null,
        };
      });
    }
  }, [parentId]);

  useEffect(() => {
    if (state.reload == true) {
      if (categoryId.length > 0) {
        // 데이터 가져오기
        initData();
      }
    }
  }, [state.reload]);

  return (
    <Card
      loading={state.loading}
      title={title}
      headStyle={{
        borderBottom: 0,
        // fontFamily: 'Public Sans',
        // fontStyle: 'normal',
      }}
      bodyStyle={{ paddingTop: 0 }}
      bordered={false}
    >
      <Button
        style={{
          display: 'flex',
          border: 0,
          padding: 0,
          width: '100%',
          height: 35,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          background: '#7367F0',
          color: '#FFF',
          borderRadius: 4,
          // font
          fontWeight: 400,
          fontSize: '1.3rem',
          lineHeight: '2.1rem',
        }}
        onClick={(e) => {
          // onClick({ value });
          if (categoryId.length > 0) {
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: (
                  <CreateExerciseModal
                    {...props}
                    setState={setState}
                    title={'새로운 운동 생성하기'}
                    categoryId={categoryId}
                  />
                ),
              };
            });
          } else {
            // alert('소분류를 선택해 주세요');
            messageApi.info(`소분류를 선택해 주세요`);
          }
        }}
      >
        <img
          width={35}
          height={35}
          src={require('../../../assets/images/ico_plus.png')}
        />
        <div style={{ marginLeft: '1rem' }}>{`새로운 운동 생성하기`}</div>
      </Button>
      <div style={{ ...styles.body }}>
        {state?.data?.map((item, index) => {
          return (
            <ExerciseItem
              key={item?.id || index + 1}
              big={big}
              mid={mid}
              sml={sml}
              messageApi={messageApi}
              data={item}
              index={index}
              onRefresh={() => {
                setState((prev) => {
                  return {
                    ...prev,
                    reload: true,
                  };
                });
              }}
              OnCellClick={(args) => {
                const exerciseId = String(args.id).trim();
                if (exerciseId.length) {
                  setGModal((prev) => {
                    return {
                      ...prev,
                      show: true,
                      component: (
                        <EditingExerciseModal
                          {...props}
                          setState={setState}
                          title={'운동 수정하기'}
                          categoryId={categoryId}
                          exerciseId={exerciseId}
                        />
                      ),
                    };
                  });
                }
              }}
            />
          );
        })}
      </div>
    </Card>
  );
};

export default ExerciseName;
